import type { EmailT } from "~/types"
import type { FetchContext, FetchResponse } from "ofetch"

export const useEmailsStore = defineStore("emails", () => {
    const loading = ref(true)
    const map = ref({} as Record<string, EmailT>)
    const items = computed(() => Object.values(map.value))
    const error = ref(null)
    const hydrated = ref(false)

    const fetchEmails = async () => {
        console.log("Fetching emails")
        return await $fetch("/api/v1/emails", {
            onResponseError(context: FetchContext & { response: FetchResponse<any> }): Promise<void> | void {
                console.error("Failed to fetch emails", context.response)
                error.value = context.response._data
            }
        }).then((data) => {
            if (!data) {
                return
            }
            data.forEach((item: EmailT) => {
                map.value[item.alias] = item
            })
        })
    }

    // if (Object.keys(map.value).length > 0) {
    //     console.log("Using persisted emails data")
    //     loading.value = false
    //     hydrated.value = true
    // } else {
        // Signed out there are no emails to fetch. The user store calls fetchEmails
        // once a session exists.
        if (useSupabaseUser().value) fetchEmails().finally(() => loading.value = false)
        else loading.value = false
    // }

    const refreshEmail = async (emailAlias: string) => {
        try {
            const email = await $fetch(`/api/v1/emails/${emailAlias}`)
            if (email) {
                map.value[emailAlias] = email
            }
        } catch (error) {
            console.error(`Failed to refresh email ${emailAlias}:`, error)
        }
    }

    return {
        error,
        loading,
        map,
        items,
        hydrated,
        fetchEmails,
        refreshEmail
    }
}, {
    persist: {
        storage: localStorage,
        paths: ["map"],
        beforeRestore: (ctx) => {
            console.log("Before restoring emails state")
        },
        afterRestore: (ctx) => {
            console.log("Emails state restored")
        }
    }
})
